import React from 'react';
import ComingSoon from '../ComingSoon';

const Generator = () => {
    return (
        <ComingSoon 
            title="🎨 Generator"
            description="Vielseitige Generatoren für alltägliche Aufgaben"
            icon="⚡"
            features={[
                "QR-Code Generator (Text, URL, Kontakt)",
                "Passwort Generator (individuell anpassbar)",
                "UUID/GUID Generator",
                "Lorem Ipsum Generator",
                "Farbpaletten Generator",
                "Random Data Generator (JSON/CSV)"
            ]}
        />
    );
};

export default Generator;